import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosPost } from './axiosUtils';
import './axiosInterceptor';

const ValidationService = {
  async validateOrderNumber(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`orderValidation`, payload);
  },

  // MY create-team: score an order across all ongoing campaigns + sub-challenges.
  async checkOrderEligibility(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`orderEligibility`, payload);
  },

  async validatePromoOrder(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`promoOrderValidation`, payload);
  },
};
export default ValidationService;
